export class CardLinkModel {

    constructor(
        public title: string,
        public distance: string,
        /* public minPrice : number,
        public maxPrice : number,
        public currency : string, */
        public link: string,
        public recommended : boolean,
        public details: string,
        public fullAddress: string
    ) {}
}